import { KEY } from './constants'

export const SET = `${KEY}/SET`
export const SET_DOCUMENT_FOLDERS = `${KEY}/SET_DOCUMENT_FOLDERS`
export const SET_UPLOAD_STATUS = `${KEY}/SET_UPLOAD_STATUS`
export const REMOVE_DELETED_DOCUMENT = `${KEY}/REMOVE_DELETED_DOCUMENT`
